import { apiSlice } from "../apiSlice/apiSlice";

export const videosApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getVideos: builder.query({
            query: () => '/videos'
        }),
        getSingleVideo: builder.query({
            query: (id) => `/videos/${id}`
        }),
        addVideo: builder.mutation({
            query: (info) => {
                const { title, description, url, views, duration, } = info || {}
                const data = {
                    title,
                    description,
                    url,
                    views,
                    duration,
                    createdAt: new Date()
                }
                return {
                    url: '/videos',
                    method: "POST",
                    body: data
                }
            },
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                const result = await queryFulfilled;
                const { data } = result || {};

                // update data 
                dispatch(apiSlice.util.updateQueryData(
                    "getVideos",
                    undefined,
                    (draft) => {
                        draft.push(data);
                    }
                )
                );

            }
        }),
        editVideo: builder.mutation({
            query: (info) => {

                return {
                    url: `/videos/${info.id}`,
                    method: "PATCH",
                    body: info
                }
            },
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                const result = await queryFulfilled;
                const { data } = result || {};

                // update data 
                dispatch(apiSlice.util.updateQueryData(
                    "getVideos",
                    undefined,
                    (draft) => {
                        const index = draft.findIndex(single => single.id === data.id)
                        draft[index] = {
                            ...draft[index],
                            ...data
                        }
                    }
                )
                );

            }
        }),
        deleteVideo: builder.mutation({
            query: (videoId) => {
                return {
                    url: `/videos/${videoId}`,
                    method: "DELETE",
                }
            },
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // const result = await queryFulfilled;

                // update data 
                const pathResult = dispatch(
                    apiSlice.util.updateQueryData(
                        "getVideos",
                        undefined,
                        (draft) => {
                            const index = draft?.findIndex(single => single.id === arg)


                            if (index !== -1) draft.splice(index, 1)



                        }
                    )
                );
                // optimistic cache update end
                try {
                    const result = await queryFulfilled;
                } catch (err) {
                    pathResult.undo()

                }

            }
        })

    })
})
export const { useGetVideosQuery, useGetSingleVideoQuery, useAddVideoMutation, useEditVideoMutation, useDeleteVideoMutation } = videosApi;



// exmple of multiple mutation here you can delete assigmnets and mark


// import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// // Define the second mutation
// const createCommentMutation = createApi({
//   reducerPath: 'commentsApi',
//   baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
//   endpoints: (builder) => ({
//     createComment: builder.mutation({
//       query: (commentData) => ({
//         url: `/posts/${commentData.postId}/comments`,
//         method: 'POST',
//         body: commentData,
//       }),
//     }),
//   }),
// });

// // Define the first mutation
// const createPostMutation = createApi({
//   reducerPath: 'postsApi',
//   baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
//   endpoints: (builder) => ({
//     createPost: builder.mutation({
//       query: (postData) => ({
//         url: '/posts',
//         method: 'POST',
//         body: postData,
//       }),
//       async onQueryStarted(postData, { dispatch }) {
//         // Define the second mutation inside the first mutation
//         const commentData = { postId: postData.id, text: 'New comment' };
//         await createCommentMutation.endpoints.createComment(commentData).then((result) => {
//           dispatch(
//             createPostMutation.util.updateQueryData('createPost', undefined, (draft) => {
//               draft.comments.push(result.data);
//             })
//           );
//         });
//       },
//     }),
//   }),
// });

// export const { useCreatePostMutation } = createPostMutation;